import { useEffect, useState } from 'react';
import PlaybackRateCookie from 'edrolo/utils/PlaybackRateCookie';

export const usePlaybackRate = () => {
  const [playbackRate, setPlaybackRate] = useState(
    PlaybackRateCookie.get() || 1
  );
  useEffect(() => {
    PlaybackRateCookie.set(playbackRate);
  }, [playbackRate]);

  return [playbackRate, setPlaybackRate];
};
